import $ from 'jquery';

export default () => {
    function Marquee(selector, speed) {
        const parentSelector = document.querySelector(selector);
        const clone = parentSelector.innerHTML;
        const firstElement = parentSelector.children[0];
        let i = 0;      
        setInterval(function () {
          firstElement.style.marginLeft = `-${i}px`;
          if (i > firstElement.clientWidth) {
            i = 0;
          }
          i = i + speed;
        }, 0);
      }

      if($(".marquee").length > 0){
        window.addEventListener('load', Marquee('.marquee', 0.2))    
      }
};


// WEBPACK FOOTER //
// ../views/partials/marquee/marquee.js